import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretMinimizeDiagonal2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 14L20.9999 14.9628L18.012 17.9814L15.024 21L14 21L14.0001 14L21 14Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M10 3L9.03724 3.00006L6.01862 5.98801L3 8.97595L3 10L10 9.99994L10 3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconCaretMinimizeDiagonal2.js.map